// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { GoogleOAuth as GoogleOAuthClass } from './GoogleOAuth';
import { FacebookOAuth as FacebookOAuthClass } from './FacebookOAuth';

export const GoogleOAuth = new GoogleOAuthClass();
export const FacebookOAuth = new FacebookOAuthClass();
